<!-- <div class="title">
{{ 'Hypotheses' | translate }}
</div> -->
<div class="selector">
  <!-- <span class="type">
  {{ 'Objective' | translate }}
  <nb-select [(selected)]="selectedType">
    <nb-option *ngFor="let option of objectiveTypeSelectorOptions" [value]="option.value" [disabled]="option.disabled">
      {{ option.label }}
    </nb-option>
  </nb-select>
</span> -->
<span class="traj">
  {{ 'Trajectory' | translate }}
  <nb-select [(selected)]="selectedTraj" (selectedChange)="onTrajectoryChange($event)">
    @for (option of trajectorySelectorOptions; track option) {
      <nb-option [value]="option.value" [disabled]="option.disabled">
        {{ option.label }}
      </nb-option>
    }
  </nb-select>
</span>
<span class="eval">
  {{ 'Evaluation in' | translate }}
  <nb-select [(selected)]="selectedEval">
    @for (option of evaluationSelectorOptions; track option) {
      <nb-option [value]="option.value" [disabled]="option.disabled">
        {{ option.label }}
      </nb-option>
    }
  </nb-select>
</span>
</div>
